import endpoint from "../apis/endpoint";
import { generateClient } from 'aws-amplify/api';
import {
  SET_CUSTOMER_DATA,
  AUTOLOGIN_ERROR,
  FETCH_BROWSE_PRODUCTS,
  FETCH_CATEGORY_PRODUCTS,
  FETCH_SELLER_PRODUCTS,
  FETCH_SELLER,
  FETCH_PRODUCT,
  CLEAR_VALIDATION,
  REGISTER,
  INPUT_VALIDATION,
  SHOW_CART,
  SHOW_NAV_MENU,
  FETCH_CART,
  FETCH_SHIPPING_METHOD,
  FETCH_SHIPPING_INFORMATION,
  FETCH_SAVED_CARDS,
  HIDE_CART,
  HIDE_NAV_MENU,
  FETCH_CATEGORIES,
  SET_AUTHORIZATION_TOKEN,
  SET_JWT,
  FETCH_CART_PRODUCTS,
  FETCH_SHIPPING_ADDRESSES,
  SET_PAYMENT_CARD,
  FETCH_BILLING_ADDRESS,
  FETCH_SHIPPING_METHOD_CUSTOM,
  SET_SELECTED_SHIPPING_ADDRESS,
  SET_LOADER,
  SET_LOADER_CHECKOUT,
  SET_AUTOLOGIN_PRODUCT,
  SET_CHECKOUT_SUCCESS,
  SHOW_MOBILE_POPUP,
  HIDE_MOBILE_POPUP,
  SET_UPDATE_PRODUCT_DETAILS,
  FETCH_UPDATE_PRODUCT_DETAILS,
  UNSET_AUTHORIZATION_TOKEN,
  ADD_NEW_SHIPPING_ADDRESS,
  SET_OFFLINE,
  SHOW_SM_POPUP,
  HIDE_SM_POPUP,
  LOGOUT,
  SET_LOADER_CART,
  ORDER_PLACED,
  TRIGGERED_MOBILE_POPUP,
  SET_EXPIRED_LINK_DETAILS,
  UNEXPECTED_ERROR,
  FETCH_ORDERS,
  FETCH_ORDER,
  SHOW_PRODUCT_OUT_OF_STOCK,
  HIDE_PRODUCT_OUT_OF_STOCK,
  FETCH_BROWSE_PRODUCTS_PAGINATION,
  FETCH_BROWSE_PRODUCTS_MAGENTO,
  FETCH_BROWSE_PRODUCTS_MAGENTO_PAGINATION,
  FETCH_CATEGORY_PRODUCTS_MAGENTO,
  FETCH_CATEGORY_PRODUCTS_MAGENTO_PAGINATION,
  FETCH_CATEGORY_PRODUCTS_PAGINATION,
  DISABLE_CHECKOUT_BUTTON,
  ENABLE_CHECKOUT_BUTTON,
  UPDATE_PRODUCT_QTY,
  SHOW_SUPPLIED_BY_FOOTER,
  HIDE_SUPPLIED_BY_FOOTER,
  SHOW_SUPPLIED_BY_POPUP,
  HIDE_SUPPLIED_BY_POPUP,
  CLEAR_PRODUCTS,
  ENTERED_HOME_PAGE,
  LEAVING_HOME_PAGE,
  SET_AFFILIATE_SELLER_ID,
  SAVE_GIFT_CARD_DETAILS,
  REVIEW_GIFT_CARD_DETAILS,
  CLEAR_GIFT_CARD_DETAILS,
  SAVE_GIFT_CARD_SEND_TIME,
  FETCH_GIFT_CARD_DETAILS,
  FETCH_GIFT_CARD_DETAILS_BY_ID,
  REMOVE_GIFT_CARD_DETAILS_BY_CART_ITEM_ID,
  HIDE_UNEXPECTED_ERROR,
  RESET_EXPIRED_LINK_DETAILS,
  HIDE_OFFLINE_POPUP,
  FETCH_MMS_TEMPLATES,
  SAVE_GIFT_CARD_MMS_TEMPLATE,
  FETCH_PASSES,
  SAVE_GIFT_CARD_PASS,
  SHOW_MESSAGE_POPUP,
  HIDE_MESSAGE_POPUP,
  CLEAR_PRODUCT,
  SET_EMPTY_CART
} from "./types";

// ============================================================
// AMPLIFY GRAPHQL CLIENT & QUERIES
// ============================================================

let _amplifyClient = null;
function getAmplifyClient() {
  if (!_amplifyClient) {
    _amplifyClient = generateClient();
  }
  return _amplifyClient;
}

// GraphQL queries for Amplify Gen 2
const amplifyQueries = {
  getProductById: /* GraphQL */ `
    query GetProductById($productId: Int!) {
      getProductById(productId: $productId) {
        product_id seller_id sku product_name product_type price weight quantity
        description short_description image_url images status visibility
        is_approved is_deleted categories category_names store_type
        parent_product_id child_product_ids url_key is_gift_card gift_card_config
        configurable_options configurable_options_products
        created_at updated_at stripe_product_id stripe_price_id
      }
    }
  `,
  getSeller: /* GraphQL */ `
    query GetSeller($sellerId: Int!) {
      getSeller(sellerId: $sellerId) {
        seller_id email firstname lastname shop_url shop_title
        logo_pic supplied_by_image company_description website_url
        is_active stripe_account_id stripe_onboarding_complete
        created_at updated_at
      }
    }
  `,
  getSellerByShopUrl: /* GraphQL */ `
    query GetSellerByShopUrl($shopUrl: String!) {
      getSellerByShopUrl(shopUrl: $shopUrl) {
        seller_id email firstname lastname shop_url shop_title
        logo_pic supplied_by_image company_description website_url
        is_active stripe_account_id stripe_onboarding_complete
        created_at updated_at
      }
    }
  `,
  browseProducts: /* GraphQL */ `
    query BrowseProducts($storeType: String!, $limit: Int, $lastEvaluatedKey: String) {
      browseProducts(storeType: $storeType, limit: $limit, lastEvaluatedKey: $lastEvaluatedKey) {
        items {
          product_id seller_id sku product_name product_type price weight quantity
          description short_description image_url images status visibility
          is_approved is_deleted categories category_names store_type
          parent_product_id child_product_ids url_key is_gift_card
          created_at updated_at stripe_product_id stripe_price_id
        }
        lastEvaluatedKey count hasMore
      }
    }
  `,
  getProductsByCategory: /* GraphQL */ `
    query GetProductsByCategory($categoryId: Int!, $limit: Int, $lastEvaluatedKey: String) {
      getProductsByCategory(categoryId: $categoryId, limit: $limit, lastEvaluatedKey: $lastEvaluatedKey) {
        items {
          product_id seller_id sku product_name product_type price weight quantity
          description short_description image_url images status visibility
          is_approved is_deleted categories category_names store_type
          parent_product_id child_product_ids url_key is_gift_card
          created_at updated_at stripe_product_id stripe_price_id
        }
        lastEvaluatedKey count hasMore
      }
    }
  `,
  getCategories: /* GraphQL */ `
    query GetCategories($activeOnly: Boolean, $menuOnly: Boolean) {
      getCategories(activeOnly: $activeOnly, menuOnly: $menuOnly) {
        items {
          category_id name parent_id level path url_key
          is_active position include_in_menu description image_url
          created_at updated_at
        }
        count
      }
    }
  `,
  getProductsBySeller: /* GraphQL */ `
    query GetProductsBySeller($sellerId: Int!, $limit: Int, $lastEvaluatedKey: String) {
      getProductsBySeller(sellerId: $sellerId, limit: $limit, lastEvaluatedKey: $lastEvaluatedKey) {
        items {
          product_id seller_id sku product_name product_type price weight quantity
          description short_description image_url images status visibility
          is_approved is_deleted categories category_names store_type
          parent_product_id child_product_ids url_key is_gift_card
          created_at updated_at stripe_product_id stripe_price_id
        }
        lastEvaluatedKey count hasMore
      }
    }
  `,
};

// Helper to transform DynamoDB product to expected format
function transformProduct(product) {
  if (!product) return null;
  return {
    id: product.product_id,
    name: product.product_name,
    sku: product.sku,
    price: product.price,
    qty: product.quantity,
    quantity: product.quantity,
    description: product.description,
    short_description: product.short_description,
    image: product.image_url,
    images: product.images?.length > 0
      ? product.images.map(url => typeof url === 'string' ? { url } : url)
      : product.image_url
        ? [{ url: product.image_url }]
        : [],
    type_id: product.product_type,
    product_type: product.product_type,
    is_giftcard: product.is_gift_card,
    is_gift_card: product.is_gift_card,
    gift_card_config: product.gift_card_config ? JSON.parse(product.gift_card_config) : null,
    configurable_options: product.configurable_options ? JSON.parse(product.configurable_options) : null,
    configurable_options_products: product.configurable_options_products ? JSON.parse(product.configurable_options_products) : null,
    seller_id: product.seller_id,
    categories: product.categories,
    category_names: product.category_names,
    store_type: product.store_type,
    status: product.status,
    visibility: product.visibility,
    url_key: product.url_key,
  };
}

// Helper to transform DynamoDB seller to expected format
function transformSeller(seller) {
  if (!seller) return null;
  return {
    seller_id: seller.seller_id,
    name: seller.shop_title,
    shop_title: seller.shop_title,
    shop_url: seller.shop_url,
    logo_pic: seller.logo_pic,
    email: seller.email,
    firstname: seller.firstname,
    lastname: seller.lastname,
    company_description: seller.company_description,
    supplierimage: seller.supplied_by_image,
    supplied_by_image: seller.supplied_by_image,
    website_url: seller.website_url,
    is_active: seller.is_active,
    stripe_account_id: seller.stripe_account_id,
    stripe_onboarding_complete: seller.stripe_onboarding_complete,
  };
}

// Helper to get store type from env
function getStoreType() {
  if (process.env.REACT_APP_GIFTGURU === 'true') return 'GIFTGURU';
  if (process.env.REACT_APP_TAP2BUY === 'true') return 'TAP2BUY';
  const hostname = window.location.hostname;
  if (hostname.includes('giftguru') || hostname.includes('gift.guru')) return 'GIFTGURU';
  return 'TAP2BUY';
}

const saveCartItemToLocalStorage = (product) => {
  const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
  let itemFound = false;

  cartItems.forEach((item, index) => {
    if (item.sku === product.sku) {
      if (
        product.product_type === "configurable" &&
        product.product_option &&
        product.product_option.extension_attributes &&
        product.product_option.extension_attributes.configurable_item_options
      ) {
        const newOptions = product.product_option.extension_attributes.configurable_item_options;
        const existingOptions = item.product_option.extension_attributes.configurable_item_options;

        if (
          existingOptions.length === newOptions.length &&
          existingOptions.every((opt, i) => opt.option_id === newOptions[i].option_id && opt.option_value === newOptions[i].option_value)
        ) {
          itemFound = true;
          cartItems[index].qty += product.qty;
        }
      } else {
        itemFound = true;
        cartItems[index].qty += product.qty;
      }
    }
  });

  if (!itemFound) {
    cartItems.push(product);
  }

  localStorage.setItem("cartItems", JSON.stringify(cartItems));
};

const getCartItemsFromLocalStorage = () => {
  return JSON.parse(localStorage.getItem("cartItems")) || [];
};

/**
 * Verify JWT token - Amplify version
 * Decodes the JWT to get user info and checks if user exists in DynamoDB
 */
export const verifyToken = (jwt, autologin, callback) => async (dispatch) => {
  console.log("verifyToken (Amplify)");

  try {
    // Decode the JWT to get the payload
    const parts = jwt.split('.');
    if (parts.length !== 3) {
      dispatch({ type: AUTOLOGIN_ERROR, payload: { message: 'Invalid token format' } });
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
      return;
    }

    // Decode the payload (base64url)
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    console.log("JWT payload:", payload);

    // Check if token is expired
    const now = Math.floor(Date.now() / 1000);
    if (payload.exp && payload.exp < now) {
      // Token expired
      dispatch({ type: SET_JWT, payload: jwt });
      dispatch({ type: SET_EXPIRED_LINK_DETAILS, payload: payload.mobile || '' });
      localStorage.expired_link_mobile = payload.mobile || '';

      if (callback) {
        callback({
          status: true,
          expired_link: true,
          mobile: payload.mobile,
          product_id: payload.product_id,
        });
      }
      return;
    }

    // Extract user data from JWT
    const mobile = payload.mobile || payload.sub || '';
    const isNewUser = payload.isNewUser || payload.is_new_user || false;

    // Store token and mobile
    localStorage.token = jwt;
    localStorage.mobile = mobile;

    if (isNewUser) {
      // New user - needs to complete registration
      dispatch({
        type: SET_CUSTOMER_DATA,
        payload: {
          customer: {
            mobile: mobile,
            first_name: payload.first_name || payload.firstName || '',
            last_name: payload.last_name || payload.lastName || '',
            email: payload.email || '',
          },
          new_user: true,
        },
      });
      dispatch({ type: SET_JWT, payload: jwt });

      if (callback) {
        callback({
          status: true,
          new_user: true,
          mobile: mobile,
          product_id: payload.product_id,
          product: payload.product,
          campaign_id: payload.campaign_id,
        });
      }
    } else {
      // Existing user - set auth
      localStorage.email = payload.email || '';
      localStorage.first_name = payload.first_name || payload.firstName || '';
      localStorage.last_name = payload.last_name || payload.lastName || '';

      dispatch({
        type: SET_AUTHORIZATION_TOKEN,
        payload: {
          token: jwt,
          customer: {
            mobile: mobile,
            first_name: payload.first_name || payload.firstName || '',
            last_name: payload.last_name || payload.lastName || '',
            email: payload.email || '',
          },
        },
      });
      dispatch({
        type: SET_AUTOLOGIN_PRODUCT,
        payload: {
          product_id: payload.product_id,
          product: payload.product,
        },
      });

      if (callback) {
        callback({
          status: true,
          existing_user: true,
          mobile: mobile,
          product_id: payload.product_id,
          product: payload.product,
          campaign_id: payload.campaign_id,
        });
      }
    }
  } catch (error) {
    console.log("verifyToken error", error);
    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    dispatch({ type: UNEXPECTED_ERROR });
  }
};

export const setExpiredLinkDetails = (mobile, callback) => async (dispatch) => {
  dispatch({ type: SET_EXPIRED_LINK_DETAILS, payload: mobile });
};

export const logout = (callback) => async (dispatch) => {
  dispatch({ type: UNSET_AUTHORIZATION_TOKEN });
  dispatch({ type: LOGOUT });
};

/**
 * Set authorization token and customer data
 */
export const setAuthorizationToken = (data, callback) => async (dispatch) => {
  // Store token in localStorage
  if (data.token) {
    localStorage.token = data.token;
  }

  dispatch({ type: SET_AUTHORIZATION_TOKEN, payload: data });

  if (callback) {
    callback();
  }
};

export const checkEmailExists = (email, callback) => async (dispatch) => {
  // Skip Magento email check - using mobile-based auth now
  // Email uniqueness is not enforced in the new DynamoDB-based auth
  console.log('checkEmailExists (Amplify) - skipping check, proceeding with registration');

  if (callback) {
    callback();
  }
};

// Legacy Magento version (kept for reference)
export const checkEmailExistsMagento = (email, callback) => async (dispatch) => {
  let response;
  try {
    response = await endpoint.post(
      "/rest/default/V1/customers/isEmailAvailable",
      {
        customerEmail: email,
        websiteId: 1,
      }
    );

    if (!response.data) {
      dispatch({
        type: INPUT_VALIDATION,
        payload: {
          email: ["The email you entered already exists"],
        },
      });
      dispatch({
        type: SET_LOADER,
        payload: {
          show: false,
          message: null,
        },
      });
    }
  } catch (error) {
    console.log("error", error);
    console.log("error.name", error.name);
    console.log("error.message", error.message);

    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

    if (error.response) {
      console.log("error response");
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);

      dispatch({ type: UNEXPECTED_ERROR });
    } else if (error.request) {
      console.log("error request");
      console.log(error.request);

      dispatch({ type: SET_OFFLINE });
    }
  }

  if (response && response.data) {
    if (callback) {
      callback();
    }
  }
};

// Store pagination cursor for browse products
let browseProductsLastKey = null;

export const fetchBrowseProducts =
  (page, products, callback) => async (dispatch) => {
    try {
      console.log("fetchBrowseProducts (Amplify)", { page, existingProducts: products?.length });

      const client = getAmplifyClient();
      const storeType = getStoreType();

      // Reset pagination on page 1
      if (page === 1) {
        browseProductsLastKey = null;
      }

      const response = await client.graphql({
        authMode: 'apiKey',
        query: amplifyQueries.browseProducts,
        variables: {
          storeType,
          limit: 20,
          lastEvaluatedKey: browseProductsLastKey
        },
      });

      const productsData = response.data?.browseProducts;
      const newProducts = (productsData?.items || []).map(transformProduct);
      browseProductsLastKey = productsData?.lastEvaluatedKey || null;

      console.log("fetchBrowseProducts response", { count: newProducts.length, hasMore: productsData?.hasMore });

      // Check for duplicates
      let left = newProducts.length;
      if (left > 0 && products && products.length > 0) {
        const existingIds = new Set(products.map(p => p.id));
        const firstNewId = newProducts[0]?.id;
        if (existingIds.has(firstNewId)) {
          left = 0;
        }
      }

      if (left !== 0) {
        const payload = {
          status: true,
          data: newProducts,
          hasMore: productsData?.hasMore || false
        };

        if (page === 1) {
          dispatch({ type: FETCH_BROWSE_PRODUCTS, payload });
        } else {
          dispatch({ type: FETCH_BROWSE_PRODUCTS_PAGINATION, payload });
        }
      }

      if (callback) {
        callback(left);
      }
    } catch (error) {
      console.log("fetchBrowseProducts error", error);
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
      dispatch({ type: UNEXPECTED_ERROR });
    }
  };

export const fetchBrowseProductsMagento =
  (page, callback) => async (dispatch) => {
    let response;
    try {
      response = await endpoint.get(
        `/rest/default/V1/products-render-info?searchCriteria[currentPage]=${page}&searchCriteria[pageSize]=10&storeId=1&currencyCode=AUD`
      );

      console.log(response);

      if (page === 1) {
        dispatch({
          type: FETCH_BROWSE_PRODUCTS_MAGENTO,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_BROWSE_PRODUCTS_MAGENTO_PAGINATION,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("error", error);
      console.log("error.name", error.name);
      console.log("error.message", error.message);

      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

      if (error.response) {
        console.log("error response");
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);

        dispatch({ type: UNEXPECTED_ERROR });
      } else if (error.request) {
        console.log("error request");
        console.log(error.request);

        dispatch({ type: SET_OFFLINE });
      }
    }

    if (response && response.data.items) {
      if (callback) {
        callback(response.data.items.length);
      }
    }
  };

// Store pagination cursors per category
const categoryProductsLastKey = {};

export const fetchCategoryProducts =
  (category_id, page, products, callback) => async (dispatch) => {
    try {
      console.log("fetchCategoryProducts (Amplify)", { category_id, page, existingProducts: products?.length });

      const client = getAmplifyClient();
      const categoryIdInt = parseInt(category_id);

      // Reset pagination on page 1
      if (page === 1) {
        categoryProductsLastKey[categoryIdInt] = null;
      }

      const response = await client.graphql({
        authMode: 'apiKey',
        query: amplifyQueries.getProductsByCategory,
        variables: {
          categoryId: categoryIdInt,
          limit: 20,
          lastEvaluatedKey: categoryProductsLastKey[categoryIdInt]
        },
      });

      const productsData = response.data?.getProductsByCategory;
      const newProducts = (productsData?.items || []).map(transformProduct);
      categoryProductsLastKey[categoryIdInt] = productsData?.lastEvaluatedKey || null;

      console.log("fetchCategoryProducts response", { count: newProducts.length, hasMore: productsData?.hasMore });

      // Check for duplicates
      let left = newProducts.length;
      if (left > 0 && products && products.length > 0) {
        const existingIds = new Set(products.map(p => p.id));
        const firstNewId = newProducts[0]?.id;
        if (existingIds.has(firstNewId)) {
          left = 0;
        }
      }

      const payload = {
        status: true,
        data: newProducts,
        hasMore: productsData?.hasMore || false
      };

      if (left !== 0 && page !== 1) {
        dispatch({ type: FETCH_CATEGORY_PRODUCTS_PAGINATION, payload });
      } else {
        dispatch({ type: FETCH_CATEGORY_PRODUCTS, payload });
      }

      if (callback) {
        callback(left);
      }
    } catch (error) {
      console.log("fetchCategoryProducts error", error);
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
      dispatch({ type: UNEXPECTED_ERROR });
    }
  };

export const fetchCategoryProductsMagento =
  (category_id, page, callback) => async (dispatch) => {
    let response;
    try {
      response = await endpoint.get(
        `/rest/default/V1/products-render-info?searchCriteria[filterGroups][0][filters][0][field]=category_id&searchCriteria[filterGroups][0][filters][0][value]=${category_id}&searchCriteria[filterGroups][0][filters][0][conditionType]=eq&searchCriteria[sortOrders][0][field]=created_at&searchCriteria[sortOrders][0][direction]=DESC&searchCriteria[currentPage]=${page}&searchCriteria[pageSize]=10&storeId=1&currencyCode=AUD`
      );

      console.log(response);

      if (page === 1) {
        dispatch({
          type: FETCH_CATEGORY_PRODUCTS_MAGENTO,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_CATEGORY_PRODUCTS_MAGENTO_PAGINATION,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("error", error);
      console.log("error.name", error.name);
      console.log("error.message", error.message);

      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

      if (error.response) {
        console.log("error response");
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);

        dispatch({ type: UNEXPECTED_ERROR });
      } else if (error.request) {
        console.log("error request");
        console.log(error.request);

        dispatch({ type: SET_OFFLINE });
      }
    }

    if (response && response.data.items) {
      if (callback) {
        callback(response.data.items.length);
      }
    }
  };

export const clearProducts = (callback) => async (dispatch) => {
  dispatch({ type: CLEAR_PRODUCTS });
};

export const clearProduct = () => {
  return { type: CLEAR_PRODUCT }
}

export const fetchProduct = (product_id, callback) => async (dispatch) => {
  try {
    console.log("fetchProduct (Amplify)", product_id);

    const client = getAmplifyClient();
    const response = await client.graphql({
      authMode: 'apiKey',
      query: amplifyQueries.getProductById,
      variables: { productId: parseInt(product_id) },
    });

    const product = response.data?.getProductById;
    console.log("fetchProduct response", product);

    if (product) {
      const transformedProduct = transformProduct(product);
      dispatch({
        type: FETCH_PRODUCT,
        payload: {
          status: true,
          data: transformedProduct
        }
      });

      if (callback) {
        callback();
      }
    } else {
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
      dispatch({ type: SHOW_MESSAGE_POPUP, payload: { header: "Product doesn't exist.", message: "The selected product does not exist." } });
    }
  } catch (error) {
    console.log("fetchProduct error", error);
    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    dispatch({ type: UNEXPECTED_ERROR });
  }
};

export const fetchSeller = (product_id, callback) => async (dispatch) => {
  try {
    console.log("fetchSeller (Amplify) for product_id", product_id);

    const client = getAmplifyClient();

    // First, get the product to find the seller_id
    const productResponse = await client.graphql({
      authMode: 'apiKey',
      query: amplifyQueries.getProductById,
      variables: { productId: parseInt(product_id) },
    });

    const product = productResponse.data?.getProductById;
    if (!product || !product.seller_id) {
      console.log("fetchSeller: product not found or no seller_id");
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
      return;
    }

    // Now fetch the seller
    const sellerResponse = await client.graphql({
      authMode: 'apiKey',
      query: amplifyQueries.getSeller,
      variables: { sellerId: product.seller_id },
    });

    const seller = sellerResponse.data?.getSeller;
    console.log("fetchSeller response", seller);

    if (seller) {
      const transformedSeller = transformSeller(seller);
      dispatch({
        type: FETCH_SELLER,
        payload: {
          status: true,
          seller: transformedSeller
        }
      });

      if (callback) {
        callback();
      }
    } else {
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    }
  } catch (error) {
    console.log("fetchSeller error", error);
    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    dispatch({ type: UNEXPECTED_ERROR });
  }
};

// New action to fetch seller directly by seller_id (more efficient when you already know the seller_id)
export const fetchSellerById = (seller_id, callback) => async (dispatch) => {
  try {
    console.log("fetchSellerById (Amplify)", seller_id);

    const client = getAmplifyClient();
    const response = await client.graphql({
      authMode: 'apiKey',
      query: amplifyQueries.getSeller,
      variables: { sellerId: parseInt(seller_id) },
    });

    const seller = response.data?.getSeller;
    console.log("fetchSellerById response", seller);

    if (seller) {
      const transformedSeller = transformSeller(seller);
      dispatch({
        type: FETCH_SELLER,
        payload: {
          status: true,
          seller: transformedSeller
        }
      });

      if (callback) {
        callback();
      }
    } else {
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    }
  } catch (error) {
    console.log("fetchSellerById error", error);
    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    dispatch({ type: UNEXPECTED_ERROR });
  }
};

export const fetchSellerInformation =
  (seller_url, callback) => async (dispatch) => {
    try {
      console.log("fetchSellerInformation (Amplify)", seller_url);

      const client = getAmplifyClient();

      // Fetch seller by shop URL
      const sellerResponse = await client.graphql({
        authMode: 'apiKey',
        query: amplifyQueries.getSellerByShopUrl,
        variables: { shopUrl: seller_url },
      });

      const seller = sellerResponse.data?.getSellerByShopUrl;
      console.log("fetchSellerInformation seller", seller);

      if (!seller) {
        dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
        dispatch({ type: SHOW_MESSAGE_POPUP, payload: { header: "Seller not found", message: "The seller profile was not found." } });
        return;
      }

      // Now fetch products for this seller
      const productsResponse = await client.graphql({
        authMode: 'apiKey',
        query: amplifyQueries.getProductsBySeller,
        variables: { sellerId: seller.seller_id, limit: 50 },
      });

      const productsData = productsResponse.data?.getProductsBySeller;
      const products = (productsData?.items || []).map(transformProduct);
      console.log("fetchSellerInformation products", products);

      const transformedSeller = transformSeller(seller);

      dispatch({
        type: FETCH_SELLER_PRODUCTS,
        payload: {
          status: true,
          seller: transformedSeller,
          data: products
        }
      });

      if (callback) {
        callback();
      }
    } catch (error) {
      console.log("fetchSellerInformation error", error);
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
      dispatch({ type: UNEXPECTED_ERROR });
    }
  };

export const register = (values, callback) => async (dispatch) => {
  console.log('register (Amplify) - updating customer profile');

  try {
    // Import the updateCustomerProfile function dynamically
    const { updateCustomerProfile } = await import('../hooks/useAuth');

    // Extract data from the Magento-style values object
    const customer = values.customer || {};
    const mobile = values.mobile || localStorage.mobile || '';
    const firstName = customer.firstname || '';
    const lastName = customer.lastname || '';
    const email = customer.email || '';

    // Build address JSON from the addresses array
    let addressJson = null;
    if (customer.addresses && customer.addresses.length > 0) {
      const addr = customer.addresses[0];
      addressJson = JSON.stringify({
        street: addr.street ? addr.street.join(', ') : '',
        city: addr.city || '',
        postcode: addr.postcode || '',
        country_id: addr.country_id || 'AU',
        region: addr.region?.region || '',
        region_code: addr.region?.region_code || '',
        region_id: addr.region_id || null,
        telephone: addr.telephone || mobile,
      });
    }

    console.log('register - calling updateCustomerProfile:', { mobile, firstName, lastName, email });

    const result = await updateCustomerProfile({
      mobile,
      firstName,
      lastName,
      email,
      address: addressJson,
    });

    console.log('register - result:', result);

    if (!result.success) {
      dispatch({
        type: INPUT_VALIDATION,
        payload: { general: result.message || 'Failed to update profile' },
      });
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    } else {
      delete localStorage.customer;
      if (callback) {
        callback();
      }
    }
  } catch (error) {
    console.log("register error", error);
    console.log("error.name", error.name);
    console.log("error.message", error.message);

    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    dispatch({ type: UNEXPECTED_ERROR });
  }
};

/**
 * Send mobile code - wrapper for Amplify version
 * Accepts legacy format { mobile: "..." } or direct mobile string
 */
export const sendMobileCode = (values, callback) => async (dispatch) => {
  const mobile = typeof values === 'string' ? values : values.mobile;
  return dispatch(sendMobileCodeAmplify(mobile, callback));
};

/**
 * Confirm mobile code - wrapper for Amplify version
 * Accepts legacy format { mobile: "...", mobile_code: "..." }
 */
export const confirmMobileCode = (values, callback) => async (dispatch) => {
  const mobile = values.mobile;
  const code = values.mobile_code || values.code;
  return dispatch(confirmMobileCodeAmplify(mobile, code, (result) => {
    if (callback) {
      // Convert to legacy callback format (just the token)
      callback(result?.token);
    }
  }));
};

// ============================================================
// AMPLIFY AUTH GRAPHQL OPERATIONS
// ============================================================

const amplifyAuthQueries = {
  sendMobileCode: /* GraphQL */ `
    mutation SendMobileCode($mobile: String!) {
      sendMobileCode(mobile: $mobile) {
        success
        message
        mobile
      }
    }
  `,

  confirmMobileCode: /* GraphQL */ `
    mutation ConfirmMobileCode($mobile: String!, $code: String!) {
      confirmMobileCode(mobile: $mobile, code: $code) {
        success
        message
        token
        user {
          mobile
          first_name
          last_name
          email
          opt_in_flag
        }
        isNewUser
      }
    }
  `,
};

/**
 * Send mobile verification code via Amplify
 */
export const sendMobileCodeAmplify = (mobile, callback) => async (dispatch) => {
  try {
    console.log('sendMobileCodeAmplify (Amplify)', mobile);

    const client = getAmplifyClient();
    const response = await client.graphql({
      authMode: 'apiKey',
      query: amplifyAuthQueries.sendMobileCode,
      variables: { mobile },
    });

    const result = response.data?.sendMobileCode;
    console.log('sendMobileCodeAmplify response', result);

    if (!result?.success) {
      dispatch({
        type: INPUT_VALIDATION,
        payload: { mobile_code: [result?.message || 'Failed to send code'] },
      });
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
      return;
    }

    if (callback) {
      callback();
    }
  } catch (error) {
    console.log('sendMobileCodeAmplify error', error);
    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    dispatch({
      type: INPUT_VALIDATION,
      payload: { mobile_code: ['Failed to send verification code. Please try again.'] },
    });
  }
};

/**
 * Confirm mobile verification code via Amplify
 * Returns JWT token and user info, handles login/registration flow
 */
export const confirmMobileCodeAmplify = (mobile, code, callback) => async (dispatch) => {
  try {
    console.log('confirmMobileCodeAmplify (Amplify)', { mobile, code: '****' });

    const client = getAmplifyClient();
    const response = await client.graphql({
      authMode: 'apiKey',
      query: amplifyAuthQueries.confirmMobileCode,
      variables: { mobile, code },
    });

    const result = response.data?.confirmMobileCode;
    console.log('confirmMobileCodeAmplify response', result);

    if (!result?.success) {
      dispatch({
        type: INPUT_VALIDATION,
        payload: { mobile_code: [result?.message || 'Invalid verification code'] },
      });
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
      return;
    }

    const { token, user, isNewUser } = result;

    // Store token and mobile in localStorage
    localStorage.token = token;
    localStorage.mobile = user?.mobile || mobile;

    if (isNewUser) {
      // New user - store data for registration
      dispatch({
        type: SET_CUSTOMER_DATA,
        payload: {
          customer: {
            mobile: user?.mobile || mobile,
            first_name: user?.first_name || '',
            last_name: user?.last_name || '',
            email: user?.email || '',
          },
          new_user: true,
        },
      });
      dispatch({ type: SET_JWT, payload: token });
    } else {
      // Existing user - set authorization
      localStorage.email = user?.email || '';
      localStorage.first_name = user?.first_name || '';
      localStorage.last_name = user?.last_name || '';

      dispatch({
        type: SET_AUTHORIZATION_TOKEN,
        payload: {
          token: token,
          customer: {
            mobile: user?.mobile || mobile,
            first_name: user?.first_name || '',
            last_name: user?.last_name || '',
            email: user?.email || '',
            opt_in_flag: user?.opt_in_flag || 0,
          },
        },
      });
    }

    if (callback) {
      callback({
        token,
        isNewUser,
        user,
      });
    }
  } catch (error) {
    console.log('confirmMobileCodeAmplify error', error);
    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    dispatch({
      type: INPUT_VALIDATION,
      payload: { mobile_code: ['Failed to verify code. Please try again.'] },
    });
  }
};

export const showCart = (callback) => async (dispatch) => {
  dispatch({ type: SHOW_CART });
};

export const showNavMenu = (callback) => async (dispatch) => {
  dispatch({ type: SHOW_NAV_MENU });
};

export const hideCart = (callback) => async (dispatch) => {
  dispatch({ type: HIDE_CART });
};

export const hideNavMenu = (callback) => async (dispatch) => {
  dispatch({ type: HIDE_NAV_MENU });
};

export const showSMPopup = (callback) => async (dispatch) => {
  dispatch({ type: SHOW_SM_POPUP });
};

export const hideSMPopup = (callback) => async (dispatch) => {
  dispatch({ type: HIDE_SM_POPUP });
};

export const showMobilePopup = (callback) => async (dispatch) => {
  dispatch({ type: SHOW_MOBILE_POPUP });
};

export const hideMobilePopup = (callback) => async (dispatch) => {
  dispatch({ type: HIDE_MOBILE_POPUP });
};

export const showUnexpectedErrorPopup = (callback) => async (dispatch) => {
  dispatch({ type: UNEXPECTED_ERROR });
};

export const hideUnexpectedErrorPopup = (callback) => async (dispatch) => {
  dispatch({ type: HIDE_UNEXPECTED_ERROR });
};

export const hideOfflinePopup = (callback) => async (dispatch) => {
  dispatch({ type: HIDE_OFFLINE_POPUP });
};

/**
 * Fetch cart from localStorage (Amplify version - no Magento)
 * Cart is now managed entirely in localStorage
 */
export const fetchCart = (callback) => async (dispatch) => {
  try {
    console.log("fetchCart (localStorage)");

    // Get cart items from localStorage
    const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];

    // Build a cart object compatible with existing code
    const cart = {
      id: 'local-cart',
      items: cartItems,
      items_count: cartItems.length,
      items_qty: cartItems.reduce((sum, item) => sum + (item.qty || 1), 0),
    };

    console.log("fetchCart cart", cart);

    dispatch({ type: FETCH_CART, payload: cart });

    // Get shipping addresses from localStorage if available
    const shippingAddresses = JSON.parse(localStorage.getItem("shippingAddresses")) || [];
    if (shippingAddresses.length > 0) {
      dispatch({
        type: FETCH_SHIPPING_ADDRESSES,
        payload: {
          customer: {
            addresses: shippingAddresses,
            default_shipping: shippingAddresses[0]?.id || null,
            default_billing: shippingAddresses[0]?.id || null
          }
        },
      });
    }

    // Get selected shipping address from localStorage if available
    const selectedShippingAddress = JSON.parse(localStorage.getItem("selectedShippingAddress"));
    if (selectedShippingAddress) {
      dispatch({ type: SET_SELECTED_SHIPPING_ADDRESS, payload: selectedShippingAddress });
    } else if (shippingAddresses.length > 0) {
      // If no selected address but we have addresses, select the first one
      dispatch({ type: SET_SELECTED_SHIPPING_ADDRESS, payload: shippingAddresses[0] });
    }

    // Get billing address from localStorage if available
    const billingAddress = JSON.parse(localStorage.getItem("billingAddress"));
    if (billingAddress) {
      dispatch({ type: FETCH_BILLING_ADDRESS, payload: { billing_address: billingAddress } });
    }

    if (callback) {
      callback();
    }
  } catch (error) {
    console.log("fetchCart error", error);
    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

    if (callback) {
      callback();
    }
  }
};

export const setEmptyCart = (callback) => (dispatch) => {
  localStorage.removeItem("cartItems");

  dispatch({ type: SET_EMPTY_CART });

  if (callback) {
    callback();
  }
};

/**
 * Clear cart - localStorage version (no longer uses Magento API)
 * Kept for backward compatibility with components that call it
 */
export const setEmptyCartbyAPI = (callback) => async (dispatch) => {
  console.log("setEmptyCartbyAPI (localStorage) - no-op, cart managed locally");

  // Just call callback immediately - cart is managed via localStorage
  if (callback) {
    callback();
  }
};

export const setCart = (product, quote_id, callback) => async (dispatch) => {
  let response;
  try {
    product.quote_id = quote_id;
    if(product.qty > 0) {
      saveCartItemToLocalStorage(product);
      dispatch({type: REVIEW_GIFT_CARD_DETAILS});
      console.log("setCart", product);
    }
    else {
      dispatch({ type: SHOW_PRODUCT_OUT_OF_STOCK });
    }
  } catch (error) {
    console.log("error", error);
    console.log("error.name", error.name);
    console.log("error.message", error.message);

    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

    if (error.response) {
      console.log("error response");
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);

      if (error.response.status === 401) {
        dispatch({ type: UNSET_AUTHORIZATION_TOKEN });
      } else if (
        error.response.status === 400 &&
        error.response.data.message === "Product that you are trying to add is not available."
      ) {
        dispatch({ type: SHOW_PRODUCT_OUT_OF_STOCK });
      } else if(
        error.response.status === 400 &&
        error.response.data.message === "The requested qty is not available" 
      ) {
        dispatch({ type: SHOW_MESSAGE_POPUP, payload: {header: "Qty not Available", message: error.response.data.message } });
      } else {
        dispatch({ type: UNEXPECTED_ERROR });
      }
    } else if (error.request) {
      console.log("error request");
      console.log(error.request);

      dispatch({ type: SET_OFFLINE });
    }
  }

  const cartItems = getCartItemsFromLocalStorage();
  if (cartItems && cartItems.length > 0) {
    if (callback) {
      callback(cartItems);
    }
  }
};

/**
 * Add to cart - localStorage version (no longer uses Magento API)
 * Cart items are already stored in localStorage, this is kept for backward compatibility
 */
export const setCartbyAPI = (product, quote_id, callback) => async (dispatch) => {
  console.log("setCartbyAPI (localStorage) - cart already in localStorage", product);

  dispatch({ type: REVIEW_GIFT_CARD_DETAILS });

  // Just call callback immediately - cart is managed via localStorage
  if (callback) {
    callback(product);
  }
};

export const createEmptyCart = (callback) => (dispatch) => {
  const existingCartItems = JSON.parse(localStorage.getItem("cartItems"));

  if (!existingCartItems) {
    localStorage.setItem("cartItems", JSON.stringify([]));
  }

  if (callback) {
    callback();
  }
};

/**
 * Create empty cart - localStorage version (no longer uses Magento API)
 * Initializes localStorage cart if needed
 */
export const createEmptyCartbyAPI = (callback) => async (dispatch) => {
  console.log("createEmptyCartbyAPI (localStorage)");

  // Initialize cart in localStorage if not exists
  const existingCartItems = JSON.parse(localStorage.getItem("cartItems"));
  if (!existingCartItems) {
    localStorage.setItem("cartItems", JSON.stringify([]));
  }

  // Just call callback immediately - cart is managed via localStorage
  if (callback) {
    callback();
  }
};

export const fetchCartProducts = (callback) => async (dispatch) => {
  try {
    const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];

    console.log("fetchCartProducts", cartItems);

    dispatch({ type: FETCH_CART_PRODUCTS, payload: { data: { items: cartItems } } });
  } catch (error) {
    console.log("error", error);
    console.log("error.name", error.name);
    console.log("error.message", error.message);

    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    dispatch({ type: UNEXPECTED_ERROR });
  }

  const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
  if (callback) {
    callback(cartItems.length);
  }
};


// GraphQL query for shipping rules
const getShippingRulesQuery = /* GraphQL */ `
  query GetShippingRules($sellerId: Int!) {
    getShippingRules(sellerId: $sellerId) {
      rule_id
      seller_id
      name
      method_code
      price
      free_shipping_threshold
      min_order_amount
      max_order_amount
      countries
      states
      postcodes
      is_active
      position
    }
  }
`;

/**
 * Fetch shipping methods for a seller (Amplify version)
 * Uses getShippingRules Lambda
 */
export const fetchCustomShippingMethods =
  (sellerId, callback) => async (dispatch) => {
    try {
      console.log('fetchCustomShippingMethods (Amplify)', sellerId);

      // Get seller_id from cart items if not provided
      let actualSellerId = sellerId;
      if (!actualSellerId) {
        const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
        if (cartItems.length > 0 && cartItems[0].seller_id) {
          actualSellerId = cartItems[0].seller_id;
        }
      }

      if (!actualSellerId) {
        // Default shipping method if no seller
        dispatch({
          type: FETCH_SHIPPING_METHOD_CUSTOM,
          payload: {
            status: true,
            data: [{
              carrier_code: 'flatrate',
              method_code: 'flatrate',
              carrier_title: 'Standard Shipping',
              method_title: 'Standard',
              amount: 10.00,
              base_amount: 10.00,
              available: true,
            }],
          },
        });
        if (callback) callback();
        return;
      }

      const client = getAmplifyClient();
      const response = await client.graphql({
        authMode: 'apiKey',
        query: getShippingRulesQuery,
        variables: { sellerId: parseInt(actualSellerId) },
      });

      const rules = response.data?.getShippingRules || [];
      console.log('fetchCustomShippingMethods response', rules);

      // Transform rules to shipping methods format
      const shippingMethods = rules
        .filter(rule => rule.is_active === 1)
        .map(rule => ({
          carrier_code: rule.method_code || 'custom',
          method_code: rule.method_code || 'custom',
          carrier_title: rule.name || 'Shipping',
          method_title: rule.name || 'Standard',
          amount: rule.price || 0,
          base_amount: rule.price || 0,
          available: true,
          free_shipping_threshold: rule.free_shipping_threshold,
        }));

      // If no rules, provide default
      if (shippingMethods.length === 0) {
        shippingMethods.push({
          carrier_code: 'flatrate',
          method_code: 'flatrate',
          carrier_title: 'Standard Shipping',
          method_title: 'Standard',
          amount: 10.00,
          base_amount: 10.00,
          available: true,
        });
      }

      dispatch({
        type: FETCH_SHIPPING_METHOD_CUSTOM,
        payload: { status: true, data: shippingMethods },
      });

      if (callback) {
        callback();
      }
    } catch (error) {
      console.log('fetchCustomShippingMethods error', error);
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

      // Provide default shipping on error
      dispatch({
        type: FETCH_SHIPPING_METHOD_CUSTOM,
        payload: {
          status: true,
          data: [{
            carrier_code: 'flatrate',
            method_code: 'flatrate',
            carrier_title: 'Standard Shipping',
            method_title: 'Standard',
            amount: 10.00,
            base_amount: 10.00,
            available: true,
          }],
        },
      });

      if (callback) callback();
    }
  };

/**
 * Fetch shipping method (Amplify version)
 * Uses getShippingRules Lambda
 */
export const fetchShippingMethod =
  (sellerId, callback) => async (dispatch) => {
    try {
      console.log('fetchShippingMethod (Amplify)', sellerId);

      // Get seller_id from cart items if not provided
      let actualSellerId = sellerId;
      if (!actualSellerId || typeof actualSellerId === 'object') {
        const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
        if (cartItems.length > 0 && cartItems[0].seller_id) {
          actualSellerId = cartItems[0].seller_id;
        }
      }

      if (!actualSellerId) {
        // Default shipping method if no seller
        dispatch({
          type: FETCH_SHIPPING_METHOD,
          payload: [{
            carrier_code: 'flatrate',
            method_code: 'flatrate',
            carrier_title: 'Standard Shipping',
            method_title: 'Standard',
            amount: 10.00,
            base_amount: 10.00,
            available: true,
          }],
        });
        if (callback) callback();
        return;
      }

      const client = getAmplifyClient();
      const response = await client.graphql({
        authMode: 'apiKey',
        query: getShippingRulesQuery,
        variables: { sellerId: parseInt(actualSellerId) },
      });

      const rules = response.data?.getShippingRules || [];
      console.log('fetchShippingMethod response', rules);

      // Transform rules to shipping methods format
      const shippingMethods = rules
        .filter(rule => rule.is_active === 1)
        .map(rule => ({
          carrier_code: rule.method_code || 'custom',
          method_code: rule.method_code || 'custom',
          carrier_title: rule.name || 'Shipping',
          method_title: rule.name || 'Standard',
          amount: rule.price || 0,
          base_amount: rule.price || 0,
          available: true,
          free_shipping_threshold: rule.free_shipping_threshold,
        }));

      // If no rules, provide default
      if (shippingMethods.length === 0) {
        shippingMethods.push({
          carrier_code: 'flatrate',
          method_code: 'flatrate',
          carrier_title: 'Standard Shipping',
          method_title: 'Standard',
          amount: 10.00,
          base_amount: 10.00,
          available: true,
        });
      }

      dispatch({ type: FETCH_SHIPPING_METHOD, payload: shippingMethods });

      if (callback) {
        callback();
      }
    } catch (error) {
      console.log('fetchShippingMethod error', error);
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

      // Provide default shipping on error
      dispatch({
        type: FETCH_SHIPPING_METHOD,
        payload: [{
          carrier_code: 'flatrate',
          method_code: 'flatrate',
          carrier_title: 'Standard Shipping',
          method_title: 'Standard',
          amount: 10.00,
          base_amount: 10.00,
          available: true,
        }],
      });

      if (callback) callback();
    }
  };

/**
 * Estimate shipping method based on address (Amplify version)
 */
export const estimateShippingMethod =
  (values, callback) => async (dispatch) => {
    try {
      console.log('estimateShippingMethod (Amplify)', values);

      // Get seller_id from cart items
      const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
      let sellerId = null;
      if (cartItems.length > 0 && cartItems[0].seller_id) {
        sellerId = cartItems[0].seller_id;
      }

      if (!sellerId) {
        // Default shipping method if no seller
        dispatch({
          type: FETCH_SHIPPING_METHOD,
          payload: [{
            carrier_code: 'flatrate',
            method_code: 'flatrate',
            carrier_title: 'Standard Shipping',
            method_title: 'Standard',
            amount: 10.00,
            base_amount: 10.00,
            available: true,
          }],
        });
        if (callback) callback();
        return;
      }

      const client = getAmplifyClient();
      const response = await client.graphql({
        authMode: 'apiKey',
        query: getShippingRulesQuery,
        variables: { sellerId: parseInt(sellerId) },
      });

      const rules = response.data?.getShippingRules || [];
      console.log('estimateShippingMethod response', rules);

      // Get cart total for free shipping check
      const cartTotal = cartItems.reduce((sum, item) => sum + (parseFloat(item.price) * (item.qty || 1)), 0);

      // Transform rules to shipping methods format and apply address filtering
      const address = values.address || {};
      const shippingMethods = rules
        .filter(rule => {
          if (rule.is_active !== 1) return false;

          // Check postcode filter
          if (rule.postcodes && rule.postcodes.length > 0 && address.postcode) {
            const postcodeMatch = rule.postcodes.some(p => address.postcode.startsWith(p));
            if (!postcodeMatch) return false;
          }

          // Check country filter
          if (rule.countries && rule.countries.length > 0 && address.country_id) {
            if (!rule.countries.includes(address.country_id)) return false;
          }

          // Check min/max order amount
          if (rule.min_order_amount && cartTotal < rule.min_order_amount) return false;
          if (rule.max_order_amount && cartTotal > rule.max_order_amount) return false;

          return true;
        })
        .map(rule => {
          // Apply free shipping if threshold met
          let price = rule.price || 0;
          if (rule.free_shipping_threshold && cartTotal >= rule.free_shipping_threshold) {
            price = 0;
          }

          return {
            carrier_code: rule.method_code || 'custom',
            method_code: rule.method_code || 'custom',
            carrier_title: rule.name || 'Shipping',
            method_title: rule.name || 'Standard',
            amount: price,
            base_amount: price,
            available: true,
          };
        });

      // If no matching rules, provide default
      if (shippingMethods.length === 0) {
        shippingMethods.push({
          carrier_code: 'flatrate',
          method_code: 'flatrate',
          carrier_title: 'Standard Shipping',
          method_title: 'Standard',
          amount: 10.00,
          base_amount: 10.00,
          available: true,
        });
      }

      dispatch({ type: FETCH_SHIPPING_METHOD, payload: shippingMethods });

      if (callback) {
        callback();
      }
    } catch (error) {
      console.log('estimateShippingMethod error', error);
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

      // Provide default shipping on error
      dispatch({
        type: FETCH_SHIPPING_METHOD,
        payload: [{
          carrier_code: 'flatrate',
          method_code: 'flatrate',
          carrier_title: 'Standard Shipping',
          method_title: 'Standard',
          amount: 10.00,
          base_amount: 10.00,
          available: true,
        }],
      });

      if (callback) callback();
    }
  };

/**
 * Fetch saved cards - Uses Amplify backend (Stripe)
 * First gets/creates Stripe customer, then fetches their saved payment methods
 */
export const fetchSavedCards = (callback) => async (dispatch) => {
  console.log("fetchSavedCards (Amplify)");

  const mobile = localStorage.mobile || '';
  const email = localStorage.email || '';
  const firstName = localStorage.first_name || '';
  const lastName = localStorage.last_name || '';
  const name = `${firstName} ${lastName}`.trim();

  if (!mobile && !email) {
    console.log("fetchSavedCards: No customer info found");
    dispatch({ type: FETCH_SAVED_CARDS, payload: { status: true, data: [] } });
    if (callback) callback();
    return;
  }

  try {
    const client = getAmplifyClient();

    // First get or create Stripe customer
    const customerResponse = await client.graphql({
      authMode: 'apiKey',
      query: amplifyCheckoutQueries.getOrCreateStripeCustomer,
      variables: { mobile, email, name },
    });

    const customerResult = customerResponse.data?.getOrCreateStripeCustomer;
    console.log('fetchSavedCards - customer result', customerResult);

    if (!customerResult?.success || !customerResult?.stripeCustomerId) {
      dispatch({ type: FETCH_SAVED_CARDS, payload: { status: true, data: [] } });
      if (callback) callback();
      return;
    }

    // Now fetch saved cards
    const cardsResponse = await client.graphql({
      authMode: 'apiKey',
      query: amplifyCheckoutQueries.getSavedCards,
      variables: { stripeCustomerId: customerResult.stripeCustomerId },
    });

    const cardsResult = cardsResponse.data?.getSavedCards;
    console.log('fetchSavedCards response', cardsResult);

    const cards = cardsResult?.cards || [];
    dispatch({
      type: FETCH_SAVED_CARDS,
      payload: { status: true, data: cards },
    });

    // Set first card as default payment method if available
    if (cards.length > 0) {
      dispatch({ type: SET_PAYMENT_CARD, payload: cards[0].id });
    }

    if (callback) {
      callback();
    }
  } catch (error) {
    console.log('fetchSavedCards error', error);
    dispatch({ type: FETCH_SAVED_CARDS, payload: { status: true, data: [] } });
    if (callback) callback();
  }
};

/**
 * Place order - DEPRECATED
 * This function is no longer used. The checkout flow now uses:
 * 1. createPaymentIntent() - Creates Stripe PaymentIntent
 * 2. stripe.confirmCardPayment() - Confirms payment client-side
 * 3. createOrderAmplify() - Saves order to DynamoDB
 *
 * @deprecated Use the new Stripe + Amplify checkout flow in CheckoutCards.js
 */
export const placeOrder = (values, callback) => async (dispatch) => {
  console.warn("placeOrder is DEPRECATED. Use createPaymentIntent + createOrderAmplify instead.");

  dispatch({
    type: INPUT_VALIDATION,
    payload: {
      card: ["Payment system updated. Please refresh and try again."],
    },
  });
  dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
};

export const setPaymentMethod = (pm, callback) => async (dispatch) => {
  dispatch({ type: SET_PAYMENT_CARD, payload: pm });

  if (callback) {
    callback();
  }
};

/**
 * Set shipping information (localStorage version - no Magento)
 * Stores shipping info in localStorage for checkout
 */
export const setShippingInformation =
  (values, callback) => async (dispatch) => {
    try {
      console.log("setShippingInformation (localStorage)", values);

      // Store shipping info in localStorage
      if (values.addressInformation) {
        const { shipping_address, billing_address, shipping_method_code, shipping_carrier_code } = values.addressInformation;

        if (shipping_address) {
          localStorage.setItem("selectedShippingAddress", JSON.stringify(shipping_address));
        }

        if (billing_address) {
          localStorage.setItem("billingAddress", JSON.stringify(billing_address));
        }

        if (shipping_method_code) {
          localStorage.setItem("shippingMethodCode", shipping_method_code);
        }

        if (shipping_carrier_code) {
          localStorage.setItem("shippingCarrierCode", shipping_carrier_code);
        }
      }

      dispatch({
        type: FETCH_SHIPPING_INFORMATION,
        payload: values,
      });

      if (callback) {
        callback();
      }
    } catch (error) {
      console.log("setShippingInformation error", error);
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

      if (callback) {
        callback();
      }
    }
  };

export const fetchCategories = (callback) => async (dispatch) => {
  try {
    console.log("fetchCategories (Amplify)");

    const client = getAmplifyClient();
    const response = await client.graphql({
      authMode: 'apiKey',
      query: amplifyQueries.getCategories,
      variables: { activeOnly: true, menuOnly: false },
    });

    const categoriesData = response.data?.getCategories;
    const categories = categoriesData?.items || [];
    console.log("fetchCategories response", categories);

    // Transform categories to expected format and build tree
    const transformedCategories = categories.map(cat => ({
      entity_id: cat.category_id,
      value: cat.name,
      name: cat.name,
      parent_id: cat.parent_id || 0,
      level: cat.level || 1,
      position: cat.position || 0,
      url_key: cat.url_key || '',
      is_active: cat.is_active,
      include_in_menu: cat.include_in_menu,
      image_url: cat.image_url,
      description: cat.description,
    }));

    // Build category tree
    function buildCategoryTree(flatCategories) {
      const categoryMap = new Map();
      const tree = [];

      flatCategories.forEach(cat => {
        categoryMap.set(cat.entity_id, { ...cat, children: [] });
      });

      categoryMap.forEach(node => {
        if (node.parent_id === 0 || node.level === 1) {
          tree.push(node);
        } else {
          const parent = categoryMap.get(node.parent_id);
          if (parent) {
            parent.children.push(node);
          } else {
            tree.push(node);
          }
        }
      });

      const sortByPosition = (a, b) => a.position - b.position;
      tree.sort(sortByPosition);
      tree.forEach(node => {
        if (node.children) node.children.sort(sortByPosition);
      });

      return tree;
    }

    const categoryTree = buildCategoryTree(transformedCategories);

    dispatch({
      type: FETCH_CATEGORIES,
      payload: {
        status: true,
        data: categoryTree
      }
    });

    if (callback) {
      callback();
    }
  } catch (error) {
    console.log("fetchCategories error", error);
    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    dispatch({ type: UNEXPECTED_ERROR });
  }
};

// export const addProductToCart = (product_id, callback) => async dispatch => {
//   const response = await endpoint.post("/rest/default/V1/mobiledigital/addproducttocart", {
//     product_id: product_id
//   }, {
//     headers: {
//       "Authorization": 'Bearer '+localStorage.token
//     }
//   });

//   console.log(response)
//   let data = JSON.parse(response.data)
//   response.data = data
//   console.log(response)

//   // dispatch({ type: FETCH_CATEGORIES, payload: response.data });

//   if (response.data.status) {
//     if(callback) {
//       callback();
//     }
//   }
// }

export const removeProductFromCart =
  (item_id, callback, no_loader = false) =>
    async (dispatch) => {
      try {
        console.log('item_iditem_id', item_id)
        const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
        const updatedCartItems = cartItems.filter(item => item.id !== item_id);
        localStorage.setItem("cartItems", JSON.stringify(updatedCartItems));
        dispatch({ type: REVIEW_GIFT_CARD_DETAILS });
      } catch (error) {
        console.log("error", error);
        console.log("error.name", error.name);
        console.log("error.message", error.message);

        if (!no_loader) {
          dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
        }

        if (error.response) {
          console.log("error response");
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);

          if (error.response.status === 401) {
            dispatch({ type: UNSET_AUTHORIZATION_TOKEN });
          } else {
            dispatch({ type: UNEXPECTED_ERROR });
          }
        } else if (error.request) {
          console.log("error request");
          console.log(error.request);

          dispatch({ type: SET_OFFLINE });
        }
      }

      const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
      if (callback) {
        callback(cartItems.length);
      }
    };

export const inputValidation = (values, callback) => async (dispatch) => {
  dispatch({ type: INPUT_VALIDATION, payload: values });
};

export const clearValidation = (callback) => async (dispatch) => {
  dispatch({ type: CLEAR_VALIDATION });
};

export const setSelectedShippingAddress =
  (address_id, addresses, callback) => async (dispatch) => {
    let selected_shipping_address = addresses.find((v) => {
      return v.id == address_id;
    });

    // if(selected_shipping_address.length > 0) {
    //   selected_shipping_address = selected_shipping_address[0]
    // } else {
    //   selected_shipping_address = null
    // }

    if (!selected_shipping_address) {
      selected_shipping_address = null;
    }

    dispatch({
      type: SET_SELECTED_SHIPPING_ADDRESS,
      payload: selected_shipping_address,
    });

    if (callback) {
      callback();
    }
  };

export const setLoader = (show, message, callback) => async (dispatch) => {
  dispatch({
    type: SET_LOADER,
    payload: {
      show,
      message,
    },
  });
};

export const setLoaderCart = (show, message, callback) => async (dispatch) => {
  dispatch({
    type: SET_LOADER_CART,
    payload: {
      show,
      message,
    },
  });
};

export const setLoaderCheckout = (type, callback) => async (dispatch) => {
  dispatch({ type: SET_LOADER_CHECKOUT, payload: type });
};

/**
 * Get checkout success info (localStorage version - no Magento)
 * The order_id is already stored from createOrderAmplify
 */
export const getCheckoutSuccess =
  (affiliate_seller_id, seller, campaign_id, callback) => async (dispatch) => {
    try {
      console.log("getCheckoutSuccess (localStorage)", { affiliate_seller_id, campaign_id });

      // Get the order_id from localStorage (set by createOrderAmplify)
      const lastOrderId = localStorage.getItem("lastOrderId") || '';
      const lastIncrementId = localStorage.getItem("lastIncrementId") || '';

      dispatch({
        type: SET_CHECKOUT_SUCCESS,
        payload: {
          order_id: lastIncrementId || lastOrderId,
          shop_name: seller?.name || seller?.shop_title || '',
        },
      });

      if (callback) {
        callback(lastIncrementId || lastOrderId);
      }
    } catch (error) {
      console.log("getCheckoutSuccess error", error);
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

      if (callback) {
        callback(null);
      }
    }
  };

export const setUpdateProductDetails =
  (details, callback) => async (dispatch) => {
    dispatch({ type: SET_UPDATE_PRODUCT_DETAILS, payload: details });
  };
export const fetchUpdateProductDetails = (callback) => async (dispatch) => {
  dispatch({ type: FETCH_UPDATE_PRODUCT_DETAILS });
};

export const addNewShippingAddress =
  (shipping_address, callback) => async (dispatch) => {
    // Save to localStorage
    const existingAddresses = JSON.parse(localStorage.getItem("shippingAddresses") || "[]");
    // Check if address already exists (by id or by matching street/postcode)
    const addressExists = existingAddresses.some(addr =>
      addr.id === shipping_address.id ||
      (addr.street?.[0] === shipping_address.street?.[0] && addr.postcode === shipping_address.postcode)
    );
    if (!addressExists) {
      existingAddresses.push(shipping_address);
      localStorage.setItem("shippingAddresses", JSON.stringify(existingAddresses));
    }

    // Also save as selected shipping address
    localStorage.setItem("selectedShippingAddress", JSON.stringify(shipping_address));

    dispatch({ type: ADD_NEW_SHIPPING_ADDRESS, payload: shipping_address });
    dispatch({
      type: SET_SELECTED_SHIPPING_ADDRESS,
      payload: shipping_address,
    });

    if (callback) {
      callback();
    }
  };

/**
 * Update customer profile (Amplify version)
 */
export const updateCustomer = (customer, callback) => async (dispatch) => {
  try {
    console.log('updateCustomer (Amplify)', customer);

    const mobile = localStorage.mobile || '';

    if (!mobile) {
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
      dispatch({ type: UNEXPECTED_ERROR });
      return;
    }

    // Build address JSON if addresses provided
    let addressJson = null;
    if (customer.addresses && customer.addresses.length > 0) {
      const addr = customer.addresses[0];
      addressJson = JSON.stringify({
        street: addr.street ? (Array.isArray(addr.street) ? addr.street.join(', ') : addr.street) : '',
        city: addr.city || '',
        postcode: addr.postcode || '',
        country_id: addr.country_id || 'AU',
        region: addr.region?.region || addr.region || '',
        region_code: addr.region?.region_code || '',
        region_id: addr.region_id || null,
        telephone: addr.telephone || mobile,
        firstname: addr.firstname || customer.firstname || '',
        lastname: addr.lastname || customer.lastname || '',
      });

      // Store in localStorage for shipping
      localStorage.setItem("shippingAddresses", JSON.stringify(customer.addresses));
    }

    const client = getAmplifyClient();
    const response = await client.graphql({
      authMode: 'apiKey',
      query: /* GraphQL */ `
        mutation UpdateCustomerProfile(
          $mobile: String!
          $firstName: String
          $lastName: String
          $email: String
          $address: String
        ) {
          updateCustomerProfile(
            mobile: $mobile
            firstName: $firstName
            lastName: $lastName
            email: $email
            address: $address
          ) {
            success
            message
          }
        }
      `,
      variables: {
        mobile,
        firstName: customer.firstname || '',
        lastName: customer.lastname || '',
        email: customer.email || '',
        address: addressJson,
      },
    });

    const result = response.data?.updateCustomerProfile;
    console.log('updateCustomer response', result);

    if (!result?.success) {
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
      dispatch({
        type: INPUT_VALIDATION,
        payload: { general: result?.message || 'Failed to update profile' },
      });
      return;
    }

    // Update localStorage with new data
    if (customer.firstname) localStorage.first_name = customer.firstname;
    if (customer.lastname) localStorage.last_name = customer.lastname;
    if (customer.email) localStorage.email = customer.email;

    if (callback) {
      callback();
    }
  } catch (error) {
    console.log('updateCustomer error', error);
    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    dispatch({ type: UNEXPECTED_ERROR });
  }
};

export const triggeredMobilePopup = (values, callback) => async (dispatch) => {
  dispatch({ type: TRIGGERED_MOBILE_POPUP, payload: values });
};

/**
 * Fetch orders - Uses Amplify backend
 * Gets customer email from localStorage and fetches orders from DynamoDB
 */
export const fetchOrders = (callback) => async (dispatch) => {
  console.log("fetchOrders (Amplify)");

  // Get customer email from localStorage
  const customerEmail = localStorage.email || '';

  if (!customerEmail) {
    console.log("fetchOrders: No customer email found");
    dispatch({ type: FETCH_ORDERS, payload: { status: true, data: [] } });
    if (callback) callback();
    return;
  }

  try {
    const client = getAmplifyClient();
    const response = await client.graphql({
      authMode: 'apiKey',
      query: amplifyCheckoutQueries.getOrders,
      variables: { customerEmail, limit: 50 },
    });

    const result = response.data?.getOrders;
    console.log('fetchOrders response', result);

    const orders = (result?.items || []).map(order => ({
      id: order.order_id || order.id,
      increment_id: order.increment_id,
      customer_name: order.customer_name,
      grand_total: order.grand_total,
      shipping_amount: order.shipping_amount,
      status: order.status,
      shipping_address: order.shipping_address,
      created_at: order.created_at,
    }));

    dispatch({
      type: FETCH_ORDERS,
      payload: { status: true, data: orders },
    });

    if (callback) {
      callback();
    }
  } catch (error) {
    console.log('fetchOrders error', error);
    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    dispatch({ type: FETCH_ORDERS, payload: { status: true, data: [] } });
    if (callback) callback();
  }
};

/**
 * Fetch single order - Uses Amplify backend
 * Gets order details from DynamoDB
 */
export const fetchOrder = (order_id, callback) => async (dispatch) => {
  console.log("fetchOrder (Amplify)", order_id);

  const customerEmail = localStorage.email || '';

  try {
    const client = getAmplifyClient();
    const response = await client.graphql({
      authMode: 'apiKey',
      query: amplifyCheckoutQueries.getOrder,
      variables: { orderId: order_id, customerEmail },
    });

    const order = response.data?.getOrder;
    console.log('fetchOrder response', order);

    if (!order) {
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
      dispatch({ type: SHOW_MESSAGE_POPUP, payload: { header: 'Order not found', message: 'The order could not be found.' } });
      return;
    }

    // Transform to expected format
    const transformedOrder = {
      id: order.order_id || order.id,
      increment_id: order.increment_id,
      customer_name: order.customer_name,
      grand_total: order.grand_total,
      shipping_amount: order.shipping_amount,
      status: order.status,
      shipping_address: order.shipping_address,
      billing_address: order.billing_address,
      items: (order.items || []).map(item => ({
        name: item.name,
        price: item.price,
        qty: item.qty,
        total: item.total || (item.price * item.qty),
      })),
      created_at: order.created_at,
    };

    dispatch({
      type: FETCH_ORDER,
      payload: { status: true, data: transformedOrder },
    });

    if (callback) {
      callback();
    }
  } catch (error) {
    console.log('fetchOrder error', error);
    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    dispatch({ type: UNEXPECTED_ERROR });
  }
};

export const hideProductOutOfStockPopup = (callback) => async (dispatch) => {
  dispatch({ type: HIDE_PRODUCT_OUT_OF_STOCK });
};

export const disableCheckoutButton = (callback) => async (dispatch) => {
  dispatch({ type: DISABLE_CHECKOUT_BUTTON });
};
export const enableCheckoutButton = (callback) => async (dispatch) => {
  dispatch({ type: ENABLE_CHECKOUT_BUTTON });
};

export const updateProductQty =
  (product_id, qty, callback) => async (dispatch) => {
    dispatch({
      type: UPDATE_PRODUCT_QTY,
      payload: {
        product_id: product_id,
        qty: qty,
      },
    });
  };

export const showSuppliedByFooter = (callback) => async (dispatch) => {
  dispatch({ type: SHOW_SUPPLIED_BY_FOOTER });
};

export const hideSuppliedByFooter = (callback) => async (dispatch) => {
  dispatch({ type: HIDE_SUPPLIED_BY_FOOTER });
};

export const showSuppliedByPopup = (callback) => async (dispatch) => {
  dispatch({ type: SHOW_SUPPLIED_BY_POPUP });
};

export const hideSuppliedByPopup = (callback) => async (dispatch) => {
  dispatch({ type: HIDE_SUPPLIED_BY_POPUP });
};

export const enteredHomePage = (callback) => async (dispatch) => {
  dispatch({ type: ENTERED_HOME_PAGE });
};

export const leavingHomePage = (callback) => async (dispatch) => {
  dispatch({ type: LEAVING_HOME_PAGE });
};

export const setAffiliateSellerId =
  (seller_id, callback) => async (dispatch) => {
    dispatch({ type: SET_AFFILIATE_SELLER_ID, payload: seller_id });
  };

export const resetExpiredLinkDetails = (callback) => async (dispatch) => {
  console.log("resetExpiredLinkDetails");
  dispatch({ type: RESET_EXPIRED_LINK_DETAILS });
};

export const saveGiftCardDetails =
  (gift_card_details, callback) => async (dispatch) => {
    let response;
    try {
      response = await endpoint.post(
        "/rest/default/V1/mobiledigital/savegiftcarddetails",
        {
          data: JSON.stringify(gift_card_details),
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        }
      );

      let data = JSON.parse(response.data);
      response.data = data;
      console.log("saveGiftCardDetails", response);

      if (!response.data.status) {
        if (response.data.input_validation) {
          dispatch({
            type: INPUT_VALIDATION,
            payload: response.data.input_validation,
          });
          dispatch({
            type: SET_LOADER,
            payload: {
              show: false,
              message: null,
            },
          });
        }
      } else {
        dispatch({ type: SAVE_GIFT_CARD_DETAILS, payload: response.data.data });
      }
    } catch (error) {
      console.log("error", error);
      console.log("error.name", error.name);
      console.log("error.message", error.message);

      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

      if (error.response) {
        console.log("error response");
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);

        if (error.response.status === 401) {
          dispatch({ type: UNSET_AUTHORIZATION_TOKEN });
        } else {
          dispatch({ type: UNEXPECTED_ERROR });
        }
      } else if (error.request) {
        console.log("error request");
        console.log(error.request);

        dispatch({ type: SET_OFFLINE });
      }
    }

    if (response && response.data.status) {
      if (callback) {
        callback(response.data.data.last_insert_id);
      }
    }
  };

export const editGiftCardDetails =
  (gift_card_details_id, gift_card_details, callback) => async (dispatch) => {
    let response;
    try {
      response = await endpoint.post(
        "/rest/default/V1/mobiledigital/editgiftcarddetails",
        {
          gift_card_details_id: gift_card_details_id,
          data: JSON.stringify(gift_card_details),
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        }
      );

      let data = JSON.parse(response.data);
      response.data = data;
      console.log("editGiftCardDetails", response);

      if (!response.data.status) {
        if (response.data.input_validation) {
          dispatch({
            type: INPUT_VALIDATION,
            payload: response.data.input_validation,
          });
          dispatch({
            type: SET_LOADER,
            payload: {
              show: false,
              message: null,
            },
          });
        }
      }
    } catch (error) {
      console.log("error", error);
      console.log("error.name", error.name);
      console.log("error.message", error.message);

      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

      if (error.response) {
        console.log("error response");
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);

        if (error.response.status === 401) {
          dispatch({ type: UNSET_AUTHORIZATION_TOKEN });
        } else {
          dispatch({ type: UNEXPECTED_ERROR });
        }
      } else if (error.request) {
        console.log("error request");
        console.log(error.request);

        dispatch({ type: SET_OFFLINE });
      }
    }

    if (response && response.data.status) {
      if (callback) {
        callback(response.data.data);
      }
    }
  };

export const removeGiftCardDetailsByCartItemId =
  (cart_id, cart_item_id, callback, no_loader = false) =>
    async (dispatch) => {
      let response;
      try {
        response = await endpoint.post(
          "/rest/default/V1/mobiledigital/deletegiftcarddetailsbycartitemid",
          {
            cart_id: cart_id,
            cart_item_id: cart_item_id,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        );

        let data = JSON.parse(response.data);
        response.data = data;
        console.log("removeGiftCardDetailsByCartItemId", response);

        dispatch({
          type: REMOVE_GIFT_CARD_DETAILS_BY_CART_ITEM_ID,
          payload: {
            cart_id: cart_id,
            cart_item_id: cart_item_id,
          },
        });
      } catch (error) {
        console.log("error", error);
        console.log("error.name", error.name);
        console.log("error.message", error.message);

        if (!no_loader) {
          dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
        }

        if (error.response) {
          console.log("error response");
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);

          if (error.response.status === 401) {
            dispatch({ type: UNSET_AUTHORIZATION_TOKEN });
          } else {
            dispatch({ type: UNEXPECTED_ERROR });
          }
        } else if (error.request) {
          console.log("error request");
          console.log(error.request);

          dispatch({ type: SET_OFFLINE });
        }
      }

      if (response && response.data.status) {
        if (callback) {
          callback();
        }
      }
    };

export const clearGiftCardDetails = (callback) => async (dispatch) => {
  dispatch({ type: CLEAR_GIFT_CARD_DETAILS });

  callback();
};

export const saveGiftCardOrder =
  (post_data, callback) => async (dispatch) => {
    let response;
    try {
      response = await endpoint.post(
        "/rest/default/V1/mobiledigital/savegiftcardorderbycart",
        post_data,
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        }
      );

      let data = JSON.parse(response.data);
      response.data = data;
      console.log("saveGiftCardOrder", response);

      if (!response.data.status) {
        dispatch({ type: SHOW_MESSAGE_POPUP, payload: {header: "Error Processing", message: "We processed your order but were unable to send your Gift Card. Please contact support." } });
      }
    } catch (error) {
      console.log("error", error);
      console.log("error.name", error.name);
      console.log("error.message", error.message);

      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

      if (error.response) {
        console.log("error response");
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);

        if (error.response.status === 401) {
          dispatch({ type: UNSET_AUTHORIZATION_TOKEN });
        } else {
          dispatch({ type: UNEXPECTED_ERROR });
        }
      } else if (error.request) {
        console.log("error request");
        console.log(error.request);

        dispatch({ type: SET_OFFLINE });
      }
    }

    if (response && response.data.status) {
      if (callback) {
        callback();
      }
    }
  };

export const saveGiftCardSendTime =
  (gift_card_details_id, date_str, delivery_timezone, callback) =>
    async (dispatch) => {
      let response;
      try {
        response = await endpoint.post(
          "/rest/default/V1/mobiledigital/savegiftcardscheduleddate",
          {
            gift_card_details_id: gift_card_details_id,
            scheduled_delivery: date_str,
            delivery_timezone: delivery_timezone,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        );

        dispatch({
          type: SAVE_GIFT_CARD_SEND_TIME,
          payload: {
            id: gift_card_details_id,
            date_str: date_str,
          },
        });

        let data = JSON.parse(response.data);
        response.data = data;
        console.log("saveGiftCardSendTime", response);
      } catch (error) {
        console.log("error", error);
        console.log("error.name", error.name);
        console.log("error.message", error.message);

        dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

        if (error.response) {
          console.log("error response");
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);

          if (error.response.status === 401) {
            dispatch({ type: UNSET_AUTHORIZATION_TOKEN });
          } else {
            dispatch({ type: UNEXPECTED_ERROR });
          }
        } else if (error.request) {
          console.log("error request");
          console.log(error.request);

          dispatch({ type: SET_OFFLINE });
        }
      }

      if (response && response.data.status) {
        if (callback) {
          callback();
        }
      }
    };

export const fetchGiftCardDetailsById =
  (gift_card_details_id, callback) => async (dispatch) => {
    let response;
    try {
      response = await endpoint.get(
        "/rest/default/V1/mobiledigital/getgiftcarddetailsbyid",
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
          params: {
            gift_card_details_id: gift_card_details_id,
          },
        }
      );

      let data = JSON.parse(response.data);
      response.data = data;
      console.log("fetchGiftCardDetailsById", response);

      dispatch({
        type: FETCH_GIFT_CARD_DETAILS_BY_ID,
        payload: response.data.data,
      });
    } catch (error) {
      console.log("error", error);
      console.log("error.name", error.name);
      console.log("error.message", error.message);

      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

      if (error.response) {
        console.log("error response");
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);

        if (error.response.status === 401) {
          dispatch({ type: UNSET_AUTHORIZATION_TOKEN });
        } else {
          dispatch({ type: UNEXPECTED_ERROR });
        }
      } else if (error.request) {
        console.log("error request");
        console.log(error.request);

        dispatch({ type: SET_OFFLINE });
      }
    }

    if (response && response.data.status) {
      if (callback) {
        callback(response.data.data);
      }
    }
  };

export const fetchGiftCardDetailsByCart =
  (cart_id, callback) => async (dispatch) => {
    let response;
    try {
      response = await endpoint.get(
        "/rest/default/V1/mobiledigital/getgiftcarddetailsbycart",
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
          params: {
            cart_id: cart_id,
          },
        }
      );

      let data = JSON.parse(response.data);
      response.data = data;
      console.log("fetchGiftCardDetailsByCart", response);

      dispatch({ type: FETCH_GIFT_CARD_DETAILS, payload: response.data.data });
    } catch (error) {
      console.log("error", error);
      console.log("error.name", error.name);
      console.log("error.message", error.message);

      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

      if (error.response) {
        console.log("error response");
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);

        if (error.response.status === 401) {
          dispatch({ type: UNSET_AUTHORIZATION_TOKEN });
        } else {
          dispatch({ type: UNEXPECTED_ERROR });
        }
      } else if (error.request) {
        console.log("error request");
        console.log(error.request);

        dispatch({ type: SET_OFFLINE });
      }
    }

    if (response && response.data.status) {
      if (callback) {
        callback(response.data.data);
      }
    }
  };

export const fetchMMSTemplates = (product_id, callback) => async (dispatch) => {
  let response;
  try {
    response = await endpoint.get(
      "/rest/default/V1/mobiledigital/getgiftcardmmstemplates",
      {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
        params: {
          product_id: product_id,
        },
      }
    );

    let data = JSON.parse(response.data);
    response.data = data;
    console.log("fetchMMSTemplates", response);

    dispatch({ type: FETCH_MMS_TEMPLATES, payload: response.data.data });
  } catch (error) {
    console.log("error", error);
    console.log("error.name", error.name);
    console.log("error.message", error.message);

    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

    if (error.response) {
      console.log("error response");
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);

      if (error.response.status === 401) {
        dispatch({ type: UNSET_AUTHORIZATION_TOKEN });
      } else {
        dispatch({ type: UNEXPECTED_ERROR });
      }
    } else if (error.request) {
      console.log("error request");
      console.log(error.request);

      dispatch({ type: SET_OFFLINE });
    }
  }

  if (response && response.data.status) {
    if (callback) {
      callback();
    }
  }
};

export const saveGiftCardMMSTemplate =
  (
    gift_card_details_id,
    mms_template_id,
    click2_giftcard_mms_template_id,
    callback
  ) =>
    async (dispatch) => {
      let response;
      try {
        response = await endpoint.post(
          "/rest/default/V1/mobiledigital/savegiftcardmmstemplate",
          {
            gift_card_details_id: gift_card_details_id,
            mms_template_id: mms_template_id,
            click2_giftcard_mms_template_id: click2_giftcard_mms_template_id,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        );

        dispatch({
          type: SAVE_GIFT_CARD_MMS_TEMPLATE,
          payload: {
            id: gift_card_details_id,
            mms_template_id: mms_template_id,
          },
        });

        let data = JSON.parse(response.data);
        response.data = data;
        console.log("saveGiftCardMMSTemplate", response);
      } catch (error) {
        console.log("error", error);
        console.log("error.name", error.name);
        console.log("error.message", error.message);

        dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

        if (error.response) {
          console.log("error response");
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);

          if (error.response.status === 401) {
            dispatch({ type: UNSET_AUTHORIZATION_TOKEN });
          } else {
            dispatch({ type: UNEXPECTED_ERROR });
          }
        } else if (error.request) {
          console.log("error request");
          console.log(error.request);

          dispatch({ type: SET_OFFLINE });
        }
      }

      if (response && response.data.status) {
        if (callback) {
          callback();
        }
      }
    };

export const fetchPasses = (product_id, callback) => async (dispatch) => {
  let response;
  try {
    response = await endpoint.get(
      "/rest/default/V1/mobiledigital/getgiftcardpasses",
      {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
        params: {
          product_id: product_id,
        },
      }
    );

    let data = JSON.parse(response.data);
    response.data = data;
    console.log("fetchPasses", response);

    dispatch({ type: FETCH_PASSES, payload: response.data.data });
  } catch (error) {
    console.log("error", error);
    console.log("error.name", error.name);
    console.log("error.message", error.message);

    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

    if (error.response) {
      console.log("error response");
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);

      if (error.response.status === 401) {
        dispatch({ type: UNSET_AUTHORIZATION_TOKEN });
      } else {
        dispatch({ type: UNEXPECTED_ERROR });
      }
    } else if (error.request) {
      console.log("error request");
      console.log(error.request);

      dispatch({ type: SET_OFFLINE });
    }
  }

  if (response && response.data.status) {
    if (callback) {
      callback();
    }
  }
};

export const saveGiftCardPass =
  (gift_card_details_id, pass_id, click2_giftcard_pass_id, callback) =>
    async (dispatch) => {
      let response;
      try {
        response = await endpoint.post(
          "/rest/default/V1/mobiledigital/savegiftcardpass",
          {
            gift_card_details_id: gift_card_details_id,
            pass_id: pass_id,
            click2_giftcard_pass_id: click2_giftcard_pass_id,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        );

        dispatch({
          type: SAVE_GIFT_CARD_PASS,
          payload: {
            id: gift_card_details_id,
            pass_id: pass_id,
          },
        });

        let data = JSON.parse(response.data);
        response.data = data;
        console.log("saveGiftCardPass", response);
      } catch (error) {
        console.log("error", error);
        console.log("error.name", error.name);
        console.log("error.message", error.message);

        dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

        if (error.response) {
          console.log("error response");
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);

          if (error.response.status === 401) {
            dispatch({ type: UNSET_AUTHORIZATION_TOKEN });
          } else {
            dispatch({ type: UNEXPECTED_ERROR });
          }
        } else if (error.request) {
          console.log("error request");
          console.log(error.request);

          dispatch({ type: SET_OFFLINE });
        }
      }

      if (response && response.data.status) {
        if (callback) {
          callback();
        }
      }
    };

export const setCustomerData = (data) => async (dispatch) => {
  dispatch({
    type: SET_CUSTOMER_DATA, payload: {
      customer: data
    }
  });
};

export const hideMessagePopup = (data) => async (dispatch) => {
  dispatch({ type: HIDE_MESSAGE_POPUP });
};

/**
 * Set default billing address (localStorage version)
 * Finds the address by ID and stores it as the default billing address
 */
export const setDefaultBillingAddress =
  (billing_address_id, callback) => async (dispatch) => {
    try {
      console.log("setDefaultBillingAddress (localStorage)", billing_address_id);

      // Get all addresses from localStorage
      const addresses = JSON.parse(localStorage.getItem("shippingAddresses") || "[]");

      // Find the address by ID
      const address = addresses.find(a => a.id === billing_address_id);

      if (address) {
        // Save as default billing address
        localStorage.setItem("billingAddress", JSON.stringify(address));

        dispatch({
          type: FETCH_BILLING_ADDRESS,
          payload: { billing_address: address },
        });
      }

      if (callback) {
        callback();
      }
    } catch (error) {
      console.log("setDefaultBillingAddress error", error);
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

      if (callback) {
        callback();
      }
    }
  };

/**
 * Set default shipping address (localStorage version)
 * Finds the address by ID and stores it as the default shipping address
 */
export const setDefaultShippingAddress =
  (shipping_address_id, callback) => async (dispatch) => {
    try {
      console.log("setDefaultShippingAddress (localStorage)", shipping_address_id);

      // Get all addresses from localStorage
      const addresses = JSON.parse(localStorage.getItem("shippingAddresses") || "[]");

      // Find the address by ID
      const address = addresses.find(a => a.id === shipping_address_id);

      if (address) {
        // Save as default shipping address
        localStorage.setItem("selectedShippingAddress", JSON.stringify(address));

        dispatch({
          type: SET_SELECTED_SHIPPING_ADDRESS,
          payload: address,
        });
      }

      if (callback) {
        callback();
      }
    } catch (error) {
      console.log("setDefaultShippingAddress error", error);
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });

      if (callback) {
        callback();
      }
    }
  };

// ============================================================
// AMPLIFY CHECKOUT/PAYMENT GRAPHQL OPERATIONS
// ============================================================

const amplifyCheckoutQueries = {
  // Create Stripe PaymentIntent
  createPaymentIntent: /* GraphQL */ `
    mutation CreatePaymentIntent(
      $sellerId: Int!
      $amount: Int!
      $currency: String
      $customerEmail: String
      $stripeCustomerId: String
      $paymentMethodId: String
      $saveCard: Boolean
    ) {
      createPaymentIntent(
        sellerId: $sellerId
        amount: $amount
        currency: $currency
        customerEmail: $customerEmail
        stripeCustomerId: $stripeCustomerId
        paymentMethodId: $paymentMethodId
        saveCard: $saveCard
      ) {
        success
        message
        clientSecret
        paymentIntentId
        status
      }
    }
  `,

  // Create order after payment
  createOrder: /* GraphQL */ `
    mutation CreateOrder(
      $sellerId: Int!
      $customer: String!
      $shippingAddress: String
      $billingAddress: String
      $items: String!
      $subtotal: Float
      $shippingAmount: Float
      $taxAmount: Float
      $grandTotal: Float!
      $shippingMethod: String
      $stripePaymentIntentId: String
      $stripeCustomerId: String
    ) {
      createOrder(
        sellerId: $sellerId
        customer: $customer
        shippingAddress: $shippingAddress
        billingAddress: $billingAddress
        items: $items
        subtotal: $subtotal
        shippingAmount: $shippingAmount
        taxAmount: $taxAmount
        grandTotal: $grandTotal
        shippingMethod: $shippingMethod
        stripePaymentIntentId: $stripePaymentIntentId
        stripeCustomerId: $stripeCustomerId
      ) {
        success
        orderId
        incrementId
        message
      }
    }
  `,

  // Get or create Stripe customer
  getOrCreateStripeCustomer: /* GraphQL */ `
    mutation GetOrCreateStripeCustomer(
      $mobile: String!
      $email: String
      $name: String
    ) {
      getOrCreateStripeCustomer(
        mobile: $mobile
        email: $email
        name: $name
      ) {
        success
        stripeCustomerId
        message
        isNew
      }
    }
  `,

  // Delete saved card
  deleteCard: /* GraphQL */ `
    mutation DeleteCard(
      $stripeCustomerId: String
      $paymentMethodId: String!
    ) {
      deleteCard(
        stripeCustomerId: $stripeCustomerId
        paymentMethodId: $paymentMethodId
      ) {
        success
        message
      }
    }
  `,

  // Get orders by customer email
  getOrders: /* GraphQL */ `
    query GetOrders($customerEmail: String!, $limit: Int) {
      getOrders(customerEmail: $customerEmail, limit: $limit) {
        success
        items {
          id
          order_id
          increment_id
          seller_id
          customer_name
          customer_email
          grand_total
          shipping_amount
          subtotal
          status
          shipping_address {
            firstname
            lastname
            street
            city
            region_code
            postcode
            country_id
            telephone
          }
          items_count
          created_at
        }
        count
        message
      }
    }
  `,

  // Get single order
  getOrder: /* GraphQL */ `
    query GetOrder($orderId: String!, $customerEmail: String) {
      getOrder(orderId: $orderId, customerEmail: $customerEmail) {
        id
        order_id
        increment_id
        seller_id
        customer_name
        customer_email
        grand_total
        shipping_amount
        tax_amount
        subtotal
        status
        shipping_method
        shipping_address {
          firstname
          lastname
          street
          city
          region
          region_code
          postcode
          country_id
          telephone
        }
        billing_address {
          firstname
          lastname
          street
          city
          region
          region_code
          postcode
          country_id
          telephone
        }
        items {
          item_id
          product_id
          sku
          name
          qty
          price
          total
          product_type
          image_url
        }
        created_at
        updated_at
      }
    }
  `,

  // Get saved cards
  getSavedCards: /* GraphQL */ `
    query GetSavedCards($stripeCustomerId: String!) {
      getSavedCards(stripeCustomerId: $stripeCustomerId) {
        success
        cards {
          id
          brand
          last4
          exp_month
          exp_year
          funding
        }
        message
      }
    }
  `,
};

// ============================================================
// AMPLIFY CHECKOUT ACTIONS
// ============================================================

/**
 * Create a Stripe PaymentIntent
 */
export const createPaymentIntent = (
  sellerId,
  amount,
  customerEmail,
  stripeCustomerId,
  paymentMethodId,
  saveCard,
  callback
) => async (dispatch) => {
  try {
    console.log('createPaymentIntent (Amplify)', { sellerId, amount, customerEmail });

    const client = getAmplifyClient();
    const response = await client.graphql({
      authMode: 'apiKey',
      query: amplifyCheckoutQueries.createPaymentIntent,
      variables: {
        sellerId: parseInt(sellerId),
        amount: Math.round(amount * 100), // Convert to cents
        currency: 'aud',
        customerEmail,
        stripeCustomerId,
        paymentMethodId,
        saveCard,
      },
    });

    const result = response.data?.createPaymentIntent;
    console.log('createPaymentIntent response', result);

    if (!result?.success) {
      dispatch({
        type: INPUT_VALIDATION,
        payload: { card: [result?.message || 'Failed to create payment intent'] },
      });
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
      return;
    }

    if (callback) {
      callback(result);
    }
  } catch (error) {
    console.log('createPaymentIntent error', error);
    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    dispatch({
      type: INPUT_VALIDATION,
      payload: { card: ['Failed to process payment. Please try again.'] },
    });
  }
};

/**
 * Create order after successful payment
 */
export const createOrderAmplify = (orderData, callback) => async (dispatch) => {
  try {
    console.log('createOrderAmplify (Amplify)', orderData);

    const client = getAmplifyClient();
    const response = await client.graphql({
      authMode: 'apiKey',
      query: amplifyCheckoutQueries.createOrder,
      variables: {
        sellerId: parseInt(orderData.sellerId),
        customer: JSON.stringify(orderData.customer),
        shippingAddress: orderData.shippingAddress ? JSON.stringify(orderData.shippingAddress) : null,
        billingAddress: orderData.billingAddress ? JSON.stringify(orderData.billingAddress) : null,
        items: JSON.stringify(orderData.items),
        subtotal: orderData.subtotal || 0,
        shippingAmount: orderData.shippingAmount || 0,
        taxAmount: orderData.taxAmount || 0,
        grandTotal: orderData.grandTotal,
        shippingMethod: orderData.shippingMethod || 'standard',
        stripePaymentIntentId: orderData.stripePaymentIntentId,
        stripeCustomerId: orderData.stripeCustomerId,
      },
    });

    const result = response.data?.createOrder;
    console.log('createOrderAmplify response', result);

    if (!result?.success) {
      dispatch({ type: UNEXPECTED_ERROR });
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
      return;
    }

    // Store order ID in localStorage for getCheckoutSuccess
    localStorage.setItem("lastOrderId", result.orderId || '');
    localStorage.setItem("lastIncrementId", result.incrementId || '');

    dispatch({
      type: SET_CHECKOUT_SUCCESS,
      payload: {
        order_id: result.incrementId || result.orderId,
        shop_name: orderData.shopName || '',
      },
    });
    dispatch({ type: ORDER_PLACED });

    if (callback) {
      callback(result);
    }
  } catch (error) {
    console.log('createOrderAmplify error', error);
    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    dispatch({ type: UNEXPECTED_ERROR });
  }
};

/**
 * Get or create Stripe customer
 */
export const getOrCreateStripeCustomer = (mobile, email, name, callback) => async (dispatch) => {
  try {
    console.log('getOrCreateStripeCustomer (Amplify)', { mobile, email, name });

    const client = getAmplifyClient();
    const response = await client.graphql({
      authMode: 'apiKey',
      query: amplifyCheckoutQueries.getOrCreateStripeCustomer,
      variables: { mobile, email, name },
    });

    const result = response.data?.getOrCreateStripeCustomer;
    console.log('getOrCreateStripeCustomer response', result);

    if (callback) {
      callback(result);
    }
  } catch (error) {
    console.log('getOrCreateStripeCustomer error', error);
    if (callback) {
      callback({ success: false, stripeCustomerId: null, message: error.message });
    }
  }
};

/**
 * Fetch saved cards from Stripe (Amplify version)
 */
export const fetchSavedCardsAmplify = (stripeCustomerId, callback) => async (dispatch) => {
  try {
    console.log('fetchSavedCardsAmplify (Amplify)', stripeCustomerId);

    if (!stripeCustomerId) {
      dispatch({ type: FETCH_SAVED_CARDS, payload: { status: true, data: [] } });
      if (callback) callback();
      return;
    }

    const client = getAmplifyClient();
    const response = await client.graphql({
      authMode: 'apiKey',
      query: amplifyCheckoutQueries.getSavedCards,
      variables: { stripeCustomerId },
    });

    const result = response.data?.getSavedCards;
    console.log('fetchSavedCardsAmplify response', result);

    const cards = result?.cards || [];
    dispatch({
      type: FETCH_SAVED_CARDS,
      payload: { status: true, data: cards },
    });

    // Set first card as default payment method if available
    if (cards.length > 0) {
      dispatch({ type: SET_PAYMENT_CARD, payload: cards[0].id });
    }

    if (callback) {
      callback();
    }
  } catch (error) {
    console.log('fetchSavedCardsAmplify error', error);
    dispatch({ type: FETCH_SAVED_CARDS, payload: { status: true, data: [] } });
    if (callback) callback();
  }
};

/**
 * Delete saved card (Amplify version)
 */
export const deleteCardAmplify = (stripeCustomerId, paymentMethodId, callback) => async (dispatch) => {
  try {
    console.log('deleteCardAmplify (Amplify)', { stripeCustomerId, paymentMethodId });

    const client = getAmplifyClient();
    const response = await client.graphql({
      authMode: 'apiKey',
      query: amplifyCheckoutQueries.deleteCard,
      variables: { stripeCustomerId, paymentMethodId },
    });

    const result = response.data?.deleteCard;
    console.log('deleteCardAmplify response', result);

    if (callback) {
      callback(result);
    }
  } catch (error) {
    console.log('deleteCardAmplify error', error);
    if (callback) {
      callback({ success: false, message: error.message });
    }
  }
};

/**
 * Fetch orders by customer email (Amplify version)
 */
export const fetchOrdersAmplify = (customerEmail, callback) => async (dispatch) => {
  try {
    console.log('fetchOrdersAmplify (Amplify)', customerEmail);

    if (!customerEmail) {
      dispatch({ type: FETCH_ORDERS, payload: { status: true, data: [] } });
      if (callback) callback();
      return;
    }

    const client = getAmplifyClient();
    const response = await client.graphql({
      authMode: 'apiKey',
      query: amplifyCheckoutQueries.getOrders,
      variables: { customerEmail, limit: 50 },
    });

    const result = response.data?.getOrders;
    console.log('fetchOrdersAmplify response', result);

    const orders = (result?.items || []).map(order => ({
      id: order.order_id || order.id,
      increment_id: order.increment_id,
      customer_name: order.customer_name,
      grand_total: order.grand_total,
      shipping_amount: order.shipping_amount,
      status: order.status,
      shipping_address: order.shipping_address,
      created_at: order.created_at,
    }));

    dispatch({
      type: FETCH_ORDERS,
      payload: { status: true, data: orders },
    });

    if (callback) {
      callback();
    }
  } catch (error) {
    console.log('fetchOrdersAmplify error', error);
    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    dispatch({ type: UNEXPECTED_ERROR });
  }
};

/**
 * Fetch single order (Amplify version)
 */
export const fetchOrderAmplify = (orderId, customerEmail, callback) => async (dispatch) => {
  try {
    console.log('fetchOrderAmplify (Amplify)', { orderId, customerEmail });

    const client = getAmplifyClient();
    const response = await client.graphql({
      authMode: 'apiKey',
      query: amplifyCheckoutQueries.getOrder,
      variables: { orderId, customerEmail },
    });

    const order = response.data?.getOrder;
    console.log('fetchOrderAmplify response', order);

    if (!order) {
      dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
      dispatch({ type: SHOW_MESSAGE_POPUP, payload: { header: 'Order not found', message: 'The order could not be found.' } });
      return;
    }

    // Transform to expected format
    const transformedOrder = {
      id: order.order_id || order.id,
      increment_id: order.increment_id,
      customer_name: order.customer_name,
      grand_total: order.grand_total,
      shipping_amount: order.shipping_amount,
      status: order.status,
      shipping_address: order.shipping_address,
      billing_address: order.billing_address,
      items: (order.items || []).map(item => ({
        name: item.name,
        price: item.price,
        qty: item.qty,
        total: item.total || (item.price * item.qty),
      })),
      created_at: order.created_at,
    };

    dispatch({
      type: FETCH_ORDER,
      payload: { status: true, data: transformedOrder },
    });

    if (callback) {
      callback();
    }
  } catch (error) {
    console.log('fetchOrderAmplify error', error);
    dispatch({ type: SET_LOADER, payload: { show: false, message: null } });
    dispatch({ type: UNEXPECTED_ERROR });
  }
};